export class WazeType {
    static get ACCIDENT() { return 'Acidente'; }
    static get HAZARD() { return 'Perigo'; }
    static get JAM() { return 'Trânsito'; }
}

export class WazeSubType {
    static get ACCIDENT_MINOR() { return "Acidente leve"; }
    static get ACCIDENT_MAJOR() { return "Acidente Grave"; }

    static get HAZARD_ON_ROAD() { return "Perigo na via"; }

    static get HAZARD_ON_ROAD_CAR_STOPPED() { return "Veículo parado na via"; }
    static get HAZARD_ON_ROAD_CONSTRUCTION() { return "Obras"; }
    static get HAZARD_ON_ROAD_ICE() { return "Gelo recém-formado"; }
    static get HAZARD_ON_ROAD_LANE_CLOSED() { return "Via interditada"; }
    static get HAZARD_ON_ROAD_OBJECT() { return "Perigo na via"; }
    static get HAZARD_ON_ROAD_OIL() { return "Derramamento recente de óleo"; }
    static get HAZARD_ON_ROAD_POT_HOLE() { return "Buraco na Pista"; }
    static get HAZARD_ON_ROAD_ROAD_KILL() { return "Atropelamento de Animais"; }
    static get HAZARD_ON_ROAD_TRAFFIC_LIGHT_FAULT() { return "Falha no Semáforo"; }

    static get HAZARD_ON_SHOULDER() { return "Perigo no Acostamento"; }
    static get HAZARD_ON_SHOULDER_ANIMALS() { return "Animais no acostamento"; }
    static get HAZARD_ON_SHOULDER_CAR_STOPPED() { return "Veículo parado no acostamento"; }
    static get HAZARD_ON_SHOULDER_MISSING_SIGN() { return "Sinalização ausente"; }

    static get HAZARD_WEATHER() { return "Perigo climático"; }
    static get HAZARD_WEATHER_FLOOD() { return "Alagamento"; }
    static get HAZARD_WEATHER_FOG() { return "Neblina"; }
    static get HAZARD_WEATHER_FREEZING_RAIN() { return "Chuva Congelante"; }
    static get HAZARD_WEATHER_HAIL() { return "Granizo"; }
    static get HAZARD_WEATHER_HEAT_WAVE() { return "Onda de Calor"; }
    static get HAZARD_WEATHER_HEAVY_RAIN() { return "Chuva Forte"; }
    static get HAZARD_WEATHER_HEAVY_SNOW() { return "Nevasca"; }

    static get HAZARD_WEATHER_HURRICANE() { return "Furacão"; }
    static get HAZARD_WEATHER_MONSOON() { return "Monção"; }
    static get HAZARD_WEATHER_TORNADO() { return "Tornado"; }

    static get JAM_STAND_STILL_TRAFFIC() { return "Trânsito parado"; }
    static get JAM_HEAVY_TRAFFIC() { return "Engarrafamento intenso"; }
    static get JAM_MODERATE_TRAFFIC() { return "Engarrafamento moderado"; }
    static get JAM_LIGHT_TRAFFIC() { return "Engarrafamento leve"; }
}